import get from 'lodash.get'
import { IBidResponse } from '../@types/IPrebid'
import IVideoConfig from '../@types/IVideoConfig'
import { Device } from './device'

export function getBaseData(config: IVideoConfig): object {
  return {
    deviceType: Device.deviceType,
    domain: window.location.hostname.replace('www.', ''),
    generator: 'video',
    group: config.playerGroup,
    version: config.playerVersion,
    wrapperGroup: get(window, '$mediavine.web.model.versionGroup.name'),
    wrapperVersion: get(window, '$mediavine.web.model.versionGroup.version')
  }
}

export const parseAdError = (adError: object, config: IVideoConfig): object => {
  return {
    ...getBaseData(config),
    adError
  }
}
export const getBidder = ({ bidder, s2sBidder }: IBidResponse): string =>
  s2sBidder ? `${s2sBidder}_s2s` : bidder
